module.exports = __webpack_public_path__ + "static/media/splash-cathecism-loading.478a67bd.png";